/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your details to see the result.`)
};

const es_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tus datos para ver el resultado.`)
};

const de_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deine Daten ein, um das Ergebnis zu sehen.`)
};

const nl_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul je gegevens in om het resultaat te zien.`)
};

const fr_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez vos informations pour voir le résultat.`)
};

const it_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci i tuoi dati per vedere il risultato.`)
};

const pt_br2_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preencha seus dados para ver o resultado.`)
};

const pt_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza os seus dados para ver o resultado.`)
};

const ja_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果を見るには詳細を入力してください。`)
};

const zh_h_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入你的信息以查看结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const h_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.h_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("h_hint", locale)
	if (locale === "en") return en_h_hint(inputs)
	if (locale === "es") return es_h_hint(inputs)
	if (locale === "de") return de_h_hint(inputs)
	if (locale === "nl") return nl_h_hint(inputs)
	if (locale === "fr") return fr_h_hint(inputs)
	if (locale === "it") return it_h_hint(inputs)
	if (locale === "pt-BR") return pt_br2_h_hint(inputs)
	if (locale === "pt") return pt_h_hint(inputs)
	if (locale === "ja") return ja_h_hint(inputs)
	return zh_h_hint(inputs)
};